module.exports = __webpack_public_path__ + "static/media/onOffice_Logo2024_white.3c356ab8.png";